<template lang="pug">
  b-form-group.slack-notify-toggle
    b-form-radio-group(
      v-model="localValue"
      name="slack-notify"
      buttons
      button-variant="light"
      :disabled="disabled"
    )
      b-form-radio(
        :value="SlackNotifyStatus.DISABLED"
        button-class="slack-btn"
        title="off",
        v-b-tooltip.hover.top="'Disabled'"
      )
        i.las.la-bell-slash(title="Off")
  
      b-form-radio(
        :value="SlackNotifyStatus.ENABLED"
        button-class="slack-btn"
        title="active",
        v-b-tooltip.hover.top="'Enabled'"
      )
        i.las.la-bell(title="Active")
  
      b-form-radio(
        :value="SlackNotifyStatus.ENABLED_WITH_MENTION"
        button-class="slack-btn"
        title="active with @mention",
        v-b-tooltip.hover.top="'Enabled with @mention'"
      )
        i.lab.la-slack(title="Active + Slack")

    span.notification-label.ml-3 {{ label }}    
  </template>
  
  <script>
  import Vue from "vue";
  
  export const SlackNotifyStatus = {
    DISABLED: 0,
    ENABLED: 1,
    ENABLED_WITH_MENTION: 2,
  };
  
  export default Vue.extend({
    name: "SlackNotifyToggle",
    props: {
      value: {
        type: Number,
        default: SlackNotifyStatus.DISABLED,
      },
      disabled: Boolean,
      label: String,
    },
    data() {
      return {
        SlackNotifyStatus,
        localValue: this.value,
      };
    },
    watch: {
      value(v) {
        this.localValue = v;
      },
      localValue(v) {
        this.$emit("input", v);
      },
    },
  });
  </script>
  
  <style scoped>

  .slack-notify-toggle {

    .btn.active {
      background-color: #e7f1ff;
      color: #1c6ed5;
      border-color: #b6d4fe;
    }
  }
  </style>
  